import axios from "axios";

export const useLocalSettingsStore = defineStore("localSettings", () => {
    const config = useRuntimeConfig();

    const settings = useLocalStorage(
        "master-administration-localSettings-settings",
        {
            lastSeen: Date.now().toString(),
            locale: config.public.locale,
        },
    );

    watchEffect(() => {
        axios.defaults.headers.common["Accept-Language"] =
            settings.value.locale;
    });

    return toRefs(settings.value);
});
